import styled from "styled-components";

const StyledOperationsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin: 8px 0 8px 0;
  align-items: center;
`;

export const OperationsContainer = (props) => {
  return (
    <StyledOperationsContainer>{props.children}</StyledOperationsContainer>
  );
};
